import type { RequestMeta } from "./types";

export function getAwsAuthToken(storageKey: string) {
  return sessionStorage.getItem(storageKey);
}

export function buildHeaders(
  tipo: "1" | "2",
  awsAuthStorageKey: string,
  meta?: RequestMeta
) {
  const awsAuthToken = getAwsAuthToken(awsAuthStorageKey);

  const headers: Record<string, string> = {
    Accept: "application/json",
    tipo,
  };

  if (!meta?.isFile) {
    headers["Content-Type"] = "application/json";
  }

  if (awsAuthToken) {
    headers.autho_api_aws = `Bearer ${awsAuthToken}`;
  }

  if (meta?.cpf?.cpfTitular) {
    headers.cpf = meta.cpf.cpfTitular;
  }

  if (meta?.cpf?.cpfRespFinanc) {
    headers.cpf_resp_financ = meta.cpf.cpfRespFinanc;
  }

  return headers;
}